import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FlatService {

  /**
   * Permet de mettre à plat un objet
   * Code extrait de la librairie https://www.npmjs.com/package/flat
   * @param target
   * @param opts
   */
  public flatten (target, opts) {
    opts = opts || {}

    const delimiter = opts.delimiter || '.'
    const maxDepth = opts.maxDepth
    const transformKey = opts.transformKey || (key => key)
    const output = {}

    const step = (object, prev = null, currentDepth = null) => {
      currentDepth = currentDepth || 1
      Object.keys(object).forEach(function (key) {
        const value = object[key]
        const isarray = opts.safe && Array.isArray(value)
        const type = Object.prototype.toString.call(value)
        const isobject = (
          type === '[object Object]' ||
          type === '[object Array]'
        )

        const newKey = prev
          ? prev + delimiter + transformKey(key)
          : transformKey(key)

        if (!isarray && isobject && Object.keys(value).length &&
          (!opts.maxDepth || currentDepth < maxDepth)) {
          return step(value, newKey, currentDepth + 1)
        }

        output[newKey] = value
      })
    }

    step(target)

    return output
  }

}
